import React, { useContext, useEffect, useState } from 'react';
import './index.scss';
import {
    Modal,
} from 'components';
import { FileUploader } from 'components/common';
import { HomeContext, ActiveShipmentsContext, AuthContext, UploadFileContext } from 'contexts';
import {
    FILE_SUB_TYPE_SHIPMENT_DETAIL_DOCS,
    MAX_SIZE_SHIPMENT_DETAIL_DOC
} from 'actions';
import { useLocation } from 'react-router-dom';
import { getBase64DataFile } from 'utils';

export const UploadSignatureDocuments = ({
    open = false,
    onCancel,
}) => {
    const { addNewDocument, setLoading, setRefreshDocumentSignature, refreshDocumentSignature } = useContext(HomeContext);
    const { doCreateDocumentSignature } = useContext(ActiveShipmentsContext);
    const { doUploadFile } = useContext(UploadFileContext);
    const { loggedInUser } = useContext(AuthContext);
    const [arrayFiles, setArrayFiles] = useState([]);
    const [filesSelected, setFilesSelected] = useState([]);

    const location = useLocation();
    const pathnameArr = location.pathname.split('/');
    const shipmentId = pathnameArr[pathnameArr.length - 2];


    /*eslint-disable */
    useEffect(() => {
        if (!addNewDocument) {
            setArrayFiles([]);
        }
    }, [addNewDocument])

    useEffect(() => {
        const filesBase64 = async () => {
            if (arrayFiles.length > 0) {
                let filesNew = await Promise.all(Array.from(arrayFiles).map(async file => {
                    const data = await getBase64DataFile(file);
                    return {
                        name: file.name,
                        type: file.type,
                        size: file.size,
                        data,
                    };
                }));
                setFilesSelected(filesNew);
            }
        }
        filesBase64();
    }, [arrayFiles])
    /*eslint-enable */

    const handleFileRemove = file => {
        if (!file) return;
        setFilesSelected(oldFiles => [...oldFiles.filter(f => !(f.name === file.name && f.size === file.size))])
        setArrayFiles(oldFiles => [...oldFiles.filter(f => !(f.name === file.name && f.size === file.size))])
    }

    const handleCloseModal = () => {
        onCancel();
        setArrayFiles([]);
        setFilesSelected([]);
    }

    const triggerUploadToS3 = async files => {
        setLoading(true);
        files = await Promise.all(files.map(async file => {
            const arr = file.name.split('.');
            const fileExtension = arr.pop();
            const fileName = arr.join('.');
            const { id, url } = await doUploadFile({
                type: file.type,
                subType: file.subType,
                fileExtension,
                fileName,
                ocrRequired: true
            }, file.data, loggedInUser);

            return {
                ...file,
                id,
                url,
                type: file.type,
                subType: file.subType,
                fileExtension,
                fileName
            };
        }));
        setLoading(false);
        return files;
    }

    const handleSubmit = async () => {
        const Files = arrayFiles.filter(x => x.subType === undefined || x.subType === null);
        if (Files.length < 1) {
            let files = arrayFiles || [];
            // upload Files getBase64
            files = await Promise.all(Array.from(files).map(async file => {
                const data = await getBase64DataFile(file);
                return {
                    name: file.name,
                    type: 'shipping-document',
                    size: file.size,
                    subType: file.subType,
                    data,
                };
            }));
            // upload Files Trigger
            const payload = await triggerUploadToS3(files);
            if (payload.length > 0) {
                // create document-signature
                const response = await Promise.all(payload.map(item => {
                    return doCreateDocumentSignature({
                        documentId: item?.id,
                        documentName: item.fileName,
                        documentExtension: item.fileExtension,
                        type: item.type,
                        subType: item.subType,
                        shipmentId
                    });
                }));
                if(response.length > 0) {
                    setArrayFiles([]);
                    setFilesSelected([]);
                    setRefreshDocumentSignature(!refreshDocumentSignature);
                    onCancel();
                }
            }
        }
    }

    const changeDocumentsSubTypes = (file, value) => {
        let data = [...arrayFiles];
        let index = data?.findIndex(x => x.name === file.name);
        let item = data?.find(x => x.name === file.name);
        if (index !== -1) {
            item.subType = value.name;
            data[index] = item;
            setArrayFiles(data);
        }
    }

    return (
        <Modal
            open={open}
            className="tr__upload-document-modal"
            onCancel={handleCloseModal}
            title={"Upload document"}
            isBackDropClickable={false}
            cancelButton={true}
            cancelButtonClassNames="outline"
            cancelButtonType="primary"
            submitButton={true}
            submitButtonLabel={"Save"}
            onSubmitClick={handleSubmit}
            btnClasses={'justify-content-between'}
        >
            <div className="tr__view-documents page-box">
                <FileUploader
                    // handleDrop={handleFileUpload}
                    handleRemove={handleFileRemove}
                    uploadedFiles={filesSelected}
                    limitNumberUploadFile={9}
                    outputFormat='base64'
                    name="uploadDocuments"
                    mode="list"
                    limitSizePerFile={MAX_SIZE_SHIPMENT_DETAIL_DOC}
                    fileTypeApproved={['pdf']}
                    uploadInner={true}
                    uploadFileType={'shipping-document'}
                    uploadFileSubType={FILE_SUB_TYPE_SHIPMENT_DETAIL_DOCS}
                    selectType={true}
                    uploadOnSelect={false}
                    setArrayFiles={setArrayFiles}
                    changeDocumentsSubTypes={changeDocumentsSubTypes}
                // ocrRequired={true}
                >
                </FileUploader>
            </div>
        </Modal>
    )
}
